module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    ref: "media",
    staticClass: "widget-main widget-main__video"
  }, [_c('div', {
    staticClass: "widget-main__controls widget-controls"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.content.poster && !_vm.playing) ? _c('div', {
    staticClass: "widget-controls__poster"
  }, [_c('img', {
    attrs: {
      "src": _vm.content.poster.url
    }
  })]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "button"
    }
  }, [(!_vm.playing) ? _c('div', {
    staticClass: "widget-controls__play-button play-button",
    on: {
      "click": _vm.play
    }
  }) : _vm._e()])], 1), _c('video', {
    ref: "video",
    staticClass: "widget-main__video",
    class: {
      'is-playing': _vm.playing
    },
    attrs: {
      "preload": "auto"
    },
    on: {
      "click": _vm.stop,
      "playing": _vm.onStatusChange,
      "pause": _vm.onStatusChange,
      "timeupdate": _vm.onPlay,
      "ended": _vm.onEnd
    }
  }, _vm._l((_vm.content.media), function(video, index) {
    return _c('source', {
      key: index,
      attrs: {
        "src": video.url,
        "type": 'video/' + video.type
      }
    })
  }))]), (_vm.content.note) ? _c('div', {
    ref: "note",
    staticClass: "widget-note"
  }, [_vm._v(_vm._s(_vm.content.note))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a6835ab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/post/widgets/player.vue
// module id = 466
// module chunks = 0